import { orderUrl, taskUrl, userUrl, commonUrl } from '@/services/url'
import http from '@/services/http'
import type * as Types from './type'
import type { Warehouse } from '../warehousing'
import { businessTimezoneTranslate } from '../businessTimezone'
export * from './mergeOrder'

/** 执行出货 */
export const batchShipment = (data: Types.SalesOutboundBatchReqDTO) => http.admin.post('/api/sales/outbounds/batch-shipment', data)

/**批量导入 */
export const orderBatchImportApi = async (data) => await http.admin.post(orderUrl.batchImport, data)

/*批量作废订单*/
export const orderBathchVoidApi = async (data: Types.SalesOutboundBatchReqDTO) => await http.admin.post('/api/sales/outbounds/batch-cancel', data)

/** 批量拦截出库 */
export const batchInterceptApi = async (data: Types.SalesOutboundBatchReqDTO) => await http.admin.post('/api/sales/outbounds/batch-intercept', data)

/** 批量取消拆单 */
export const cancelSplitOrder = async (data) => await http.admin.post(orderUrl.cancelSplitOrderUrl, data)
// 批量释放库存
export const orderBathchReleaseStockdApi = async (data: Types.SalesOutboundBatchReqDTO) => await http.admin.post('/api/sales/outbounds/batch-release', data)

/**获取地图 url */
export const getMapUrl = (data: Types.IGetMapVo) => {
  return http.admin.post<{ url: string; requestType?: string; requestBody?: string }>(orderUrl.eMapUrl, { ...data })
}

/** 无需处理（门店关转） */
export const ignoreAbnormalOrder = async (data) => await http.admin.post(orderUrl.ignoreAbnormalUrl, data)

/** 获取订单物流轨迹 */
export const getTrackInfo = async (params: Types.TrackInfoReq) => await http.admin.get<Types.TrackInfoRes>(orderUrl.trackListUrl, { params })

/** 修改门店/出货日期 */
export const changeDoorOrDate = async (params) => await http.admin.post('/api/abnormal/outbounds/updateStation', params)

/**获取订单列表 */
export const orderSearchListApi = businessTimezoneTranslate(
  async (data: Types.SalesOutboundSearchReq) => await http.admin.post<Types.OutboundsSearchRes>('/api/sales/outbounds/search', data),
  [
    'createStartTime',
    'createEndTime',
    'outboundStartTime',
    'outboundEndTime',
    'platformCreateStartTime',
    'platformCreateEndTime',
    'shipmentEndTime',
    'shipmentStartTime',
    'pushEndTime',
    'pushStartTime',
    'cancelEndTime',
    'cancelStartTime',
    'handUpEndTime',
    'handUpStartTime',
  ],
  [
    'data.list.[].outboundTime',
    'data.list.[].createTime',
    'data.list.[].platformCreateTime',
    'data.list.[].shipmentDeadlineTime',
    'data.list.[].shipmentTime',
    'data.list.[].pushTime',
    'data.list.[].cancelTime',
    'data.list.[].handUp.handUpTime',
  ]
)

/** 批量更新平台订单 */
export const batchPlatformOrderUpdate = (data: Types.BatchPlatformOrderUpdate) => http.admin.post<Types.BatchPlatformOrderUpdateRes>('/api/tasks/order-update', data)

/** 批量恢复订单 */
export const batchRecoverOrder = (data: Types.BatchRecoverOrder) => http.admin.post<Types.BatchRecoverOrderRes>(taskUrl.batchRecoverUrl, data)

/** 根据id查订单 */
export const searchOrderById = (data) => http.admin.post(orderUrl.searchOrderById, data)

/** 挂起订单 */
export const hangUpOrder = businessTimezoneTranslate(async (data: Types.HangUpOrder) => await http.admin.post('/api/sales/outbounds/batch-hand-up', data), ['handUpTime'], [])

/** 解挂订单 */
export const hangDownOrder = (data: Types.HangUpOrder) => http.admin.post(orderUrl.hangDownOrder, data)

/** 获取订单标签总数 */
export const orderTagsInfo = businessTimezoneTranslate(
  async (data: Types.SearchCountReq) => await http.admin.post<Types.SearchCountRes>('/api/sales/outbounds/search-count', data),
  [
    'createStartTime',
    'createEndTime',
    'outboundStartTime',
    'outboundEndTime',
    'platformCreateStartTime',
    'platformCreateEndTime',
    'shipmentEndTime',
    'shipmentStartTime',
    'pushEndTime',
    'pushStartTime',
    'cancelEndTime',
    'cancelStartTime',
    'handUpEndTime',
    'handUpStartTime',
  ],
  []
)

// 根据服务产品编码获取可配送时间
export const getAvailableDeliveryDays = async (data) => http.admin.post('/api/express/get-times', data)

/** 绑定店铺列表 */
export const getBindStoreList = (params) => http.admin.get<Types.StoreListRes>(userUrl.bindStoreList, { params })

/**批量更新物流 */
export const batchUpdateExpress = async (data) => http.admin.post(orderUrl.batchUpdateExpress, data)

/** 根据商家id获取仓库信息 */
export const getExpressList = async (data?: Types.IExpressList) => http.admin.post<Warehouse[]>(commonUrl.sellerExpressList, data)

/** 批量更新偏好物流设置 */
export const batchUpdateSellerExpress = async (data) => http.admin.post(orderUrl.batchUpdateSellerExpress, data)

/**改变物流状态 */
export const changeExpressEnable = async (data: Types.IChangeExpressEnable) => http.admin.post(orderUrl.changeExpressEnable, data)

export const batchChangeExpressEnable = async (updateList: Types.IChangeExpressEnable[]) =>
  http.admin.post(orderUrl.batchChangeExpressEnable, {
    updateList,
  })

/**批量改变物流 */
export const updateExpress = async (data: Types.IUpdateSellerExpress) => http.admin.post(orderUrl.updateExpress, data)

/*获取拆单数据 */
export const getCanSplitOrders = async (data) => http.admin.post(orderUrl.getCanSplitOrders, data)
/** 批量执行拆单 **/
export const batchSplitOrder = async (data) => http.admin.post(orderUrl.batchSplitOrder, data)
/** 批量取消拆单 **/
export const batchCancelSplitOrder = async (data) => http.admin.post(orderUrl.batchCancelSplitOrder, data)

/** 获取币种转换 */
export const getExchangeRate = async (data: Types.ICurrencyConvertParam) => http.admin.post<Types.ConvertRes>('/api/currency/convert', data)
/** 获取门店关转状态数量 **/
export const searchAbnormalCount = async (data) => http.admin.post<Types.AbnormalCountType>('/api/sales/outbounds/search-abnormal-count', data)

/**获取待出库已出库的门店关转数量 */
export const searchPendingCount = () => http.admin.post<Types.SearchPendingCountReq[]>('/api/sales/outbounds/search-pending-count')

/** 是否可以创建订单 */
export const vaildCanCreateOrder = (orderMcId: string) =>
  http.admin.post<Types.CanCreateOrderRes>(`/api/sales/outbounds/can-create-order`, {
    orderMcId,
  })

/** 批量执行配货 */
export const batchAllocate = (data: Types.SalesOutboundBatchAllocateReq) => http.admin.post('/api/sales/outbounds/batch-allocate', data)

/**
 * 检查订单商品是否有异常
 */
export const checkSkuOrder = (data: Types.OutboundOrderSkuReqDTO) => http.admin.post<Types.CheckSkuOrderRes>(orderUrl.checkSkuOrder, data)

/**
 * 批量执行取消预约出货
 */
export const batchCancelShipment = (data: Types.SalesOutboundBatchAllocateReq) => http.admin.post('/api/sales/outbounds/batch-cancel-shipment-appointment', data)

/** 获取标签列表 */
export const getCustomTagsList = () => http.admin.get<Types.UpdateTagsType>('/api/sales/outbounds/tag/list')

/** 新增、更新、删除标签 */
export const updateCustomTagsList = (data: Types.UpdateTagsType) => http.admin.post('/api/sales/outbounds/tag/update', data)

/** 批量新增标签 */
export const createOutboundsTags = (data: Types.CreateOutboundsTagsType) => http.admin.post('/api/sales/outbounds/batch-create-tags', data)

/** 批量删除标签 */
export const deleteOutboundsTags = (data: Types.CreateOutboundsTagsType) => http.admin.post('/api/sales/outbounds/batch-delete-tags', data)

/** 编辑订单标签 */
export const updateOutboundsTags = (data: Types.UpdateOutboundsTagsType) => http.admin.post('/api/sales/outbounds/update-tags', data)

/** 下载面单 */
export const waybillDownload = (data: Types.IWaybillDownloadReq) => http.admin.post<Types.CanCreateOrderRes>(orderUrl.waybillDownload, data)

/** 获取出库单详情 */
export const getOutboundsDetail = (params: Types.OutboundsGetReq) =>
  http.noToast.get<Types.OutboundsGetRes>('/api/sales/outbounds/get', {
    params,
  })
/** 下载发票 */
export const invoiceDownload = (data: Types.SalesOutboundBatchReqDTO) => http.admin.post('/api/sales/outbounds/invoice-download', data)

export const calculateFreight = (data: Types.SalesOutboundFreightCalculateReqDTO) => http.admin.post<Types.CalculateFreightRes>('/api/sales/outbounds/calculate-freight', data)
/** 获取订单标签 */
export const getOrderTagList = () => http.admin.get<Types.EnumType[]>('/api/sales/outbounds/order-tag')

/**批量添加商品 */
export const batchAddOrderGoods = (data: Types.BatchAddGoodsReq) => http.admin.post('/api/sales/outbounds/batch-add-sku', data)

/**批量更换商品 */
export const batchUpdateOrderGoods = (data: Types.BatchUpdateGoodsReq) => http.admin.post('/api/sales/outbounds/batch-update-sku', data)

/**批量删除商品 */
export const batchDeleteOrderGoods = (data: Types.BatchDeleteGoodsReq) => http.admin.post('/api/sales/outbounds/batch-delete-sku', data)

export const fetchSupportBatches = (data: Types.OutboundMultiBatchesCheckReqDTO) => http.admin.post<Types.SupportRes>('/api/sales/outbounds/multi_batches/support', data)

export interface OutboundListCustomLabelUrlRespDTOItem {
  outboundOrderId: string
  /**如果为空表示要清除已有的 */
  customLabelUrl?: string
  /** 预览链接 */
  customLabelPreviewUrl?: string
}

/**
 * **接口** [updateCustomLabel↗](https://api-doc-sl.inshopline.com/#/project/Java/80/feature%2F202400402_3743_outboundorder_support_upload_waybill/interface/903d1ea7a635701820a235348c7a5720)
 * @请求头 `POST /api/tasks/update-custom-label`
 * @更新时间 `2024-03-07 11:33:55`
 */
export function postUpdateCustomLabel(data: { data: OutboundListCustomLabelUrlRespDTOItem[] }) {
  return http.admin.post<{ batchTaskId?: string }>(`/api/tasks/update-custom-label`, data)
}

/**
 * **接口** [查询所有自定义物流面单↗](https://api-doc-sl.inshopline.com/#/project/Java/80/feature%2F202400402_3743_outboundorder_support_upload_waybill/interface/0491322ae51eb337d9ebdf672c5e4fa1)
 * @请求头 `POST /api/sales/outbounds/list-custom-label`
 * @更新时间 `2024-03-07 15:42:21`
 */
export function postListCustomLabel(data: { outboundOrderIds: string[] }) {
  return http.admin.post<{ data: OutboundListCustomLabelUrlRespDTOItem[] }>(`/api/sales/outbounds/list-custom-label`, data)
}

/**
 * **接口** [batchShipmentCheck↗](https://apidoc.inshopline.com/#/project/Java/80/test/interface/dbf9d9eff10035c576930a1247301e9d)
 * @请求头 `POST /api/sales/outbounds/batch-shipment-check`
 * @更新时间 `2024-07-08 20:06:42`
 */
export function postBatchShipmentCheck(data?: Types.SalesOutboundBatchReqDTO) {
  return http.admin.post<Types.BatchShipmentCheckRes>(`/api/sales/outbounds/batch-shipment-check`, data, { toast: true })
}

interface SalesOutboundGetReqDTO {
  /**语言 */
  language?: string
  /**销售出库单号（如果优先使用）（约束：元素个数范围：[0,64]） */
  outboundOrderId?: string
  /**销售出库单短号（约束：元素个数范围：[0,64]） */
  orderShortId?: string
  /**原始地址值 */
  sourceAddress?: boolean
  /**是否包含商品结构 */
  containsProduct?: boolean
  /**是否进行多仓自动选仓，默认false
true则返回的warehouseId和warehouseName是匹配后的，
否则返回的是订单原来的 */
  chooseWarehouse?: boolean
}

interface SimpleRefundOrder {
  /**退货单ID */
  refundOrderId?: string
  /**OW退货单短号 */
  orderShortId?: string
  /**对外展示状态（待处理、退货中、已退货、已作废） */
  mainStatus?: string
}

interface GetAssociatedRefundOrderRes {
  /**出库单短号 */
  orderShortId?: string
  /**关联的退货单 */
  refundOrders?: SimpleRefundOrder[]
}

/**
 * **接口** [getAssociatedRefundOrder↗](https://apidoc.inshopline.com/#/project/Java/80/feature%2F4404_refund_opt/interface/38e45fb98ecda1825429b3d549d65bd1)
 * @请求头 `POST /api/sales/outbounds/get-associated-refund-order`
 * @更新时间 `2025-03-01 17:49:00`
 */
export function postGetAssociatedRefundOrder(data?: SalesOutboundGetReqDTO) {
  return http.admin.post<GetAssociatedRefundOrderRes>(`/api/sales/outbounds/get-associated-refund-order`, data)
}
